module.exports = __webpack_public_path__ + "img/theater.be5030ca.webp";